import React from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";

const DocumentsPageType: Page = {
  ActiveTab: "documents",
  DisplayName: "Sopimukset",

  LinkUrl: "/documents",
  Path: "/documents",
  RouteName: "documents",
};

const DocumentsPage = () => {
  return (
    <div className={DocumentsPageType.RouteName}>
      <Layout CurrentPage={DocumentsPageType}>
        <PageHeader
          Title={DocumentsPageType.DisplayName}
          SubTitle={DocumentsPageType.DisplayParentName}
          Back={false}
          Icon="file-text"
        ></PageHeader>

        <p>
          Jotain yleistä sopimuksista. Lorem ipsum dolor sit amet consectetur.
          Lorem tellus nisi nulla mauris adipiscing vitae et amet.
        </p>

        <ul className="list-unstyled">
          <li className="border-bottom py-16">
            <Link to="" target="_blank">
              <span className="bi bi-filetype-pdf me-8"></span>
              <span>Liitetiedoston nimi</span>
            </Link>
          </li>
          <li className="border-bottom py-16">
            <Link to="" target="_blank">
              <span className="bi bi-filetype-pdf me-8"></span>
              <span>Liitetiedoston nimi</span>
            </Link>
          </li>
          <li className="border-bottom py-16">
            <Link to="" target="_blank">
              <span className="bi bi-filetype-pdf me-8"></span>
              <span>Liitetiedoston nimi</span>
            </Link>
          </li>
        </ul>
      </Layout>
    </div>
  );
};

export default DocumentsPage;
